import React, { useState, useEffect } from 'react';
import { DataGrid } from '@mui/x-data-grid';
import { Link } from 'react-router-dom'; 
import { Button } from '@mui/material';
import EditImplantMarker from './editImplantMarker';
import DeleteModal from './deletemodal'; 

const ImplantMarkers = () => { // Changed to uppercase
  const [selectedRowId, setSelectedRowId] = useState(null);
  const [rows, setRows] = useState([]);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [pricingColumns, setPricingColumns] = useState([]);
  const [, setMaxPricings] = useState(0);
  const [specialPricingColumns, setSpecialPricingColumns] = useState([]);
  const [, setMaxSpecialPricings] = useState(0);
  const [showEditImplantMarker, setShowEditImplantMarker] = useState(false);
  const [selectedRowData, setSelectedRowData] = useState({
    name: '',
    priceper: '',
    isLotRequired: false,
    allowNoteForLot: false,
    isSerialRequired: false,
    allowNoteForSerial: false,
    Suppressthisattributeonreports:false,
    Suppressthisattributevaluewhenpriceiszero:false,
    Neverrolluppriceintoprocedure:false,

  });

  // const handleChange = (e) => {
  //   const { name, value } = e.target;
  //   setFormData(prevState => ({
  //     ...prevState,
  //     [name]: value
  //   }));
  // };

  const onRowsUpdate = (newRows) => {
    setRows(newRows)
  }

  const [, ] = useState({ procedureFrom: '', designMode: '', implantMarkerClass: '', procedureTo: '' });
  
  const [,] = useState(false);
  const [, ] = useState({});

  useEffect(() => {
    const fetchImplantMarkers = async () => {
      try {
        const response = await fetch('https://hms.backend.hiragroupcloud.com/api/implant-markers');
       
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        const data = await response.json();
        

        const maxPricing = Math.max(...data.data.map(item => item?.implantMarkerPricing?.length));
        setMaxPricings(maxPricing);

        const pricingColumns = [];
        for (let i = 0; i < maxPricing; i++) {
          pricingColumns.push({ field: `amount_${i+1}`, headerName: `Default price`, width: 150, align: 'center', headerAlign: 'center' });
        }
        setPricingColumns(pricingColumns);

        const maxSpecialPricing = Math.max(...data.data.map(item => item?.implantMarkerSpecialPricing?.length));
        setMaxSpecialPricings(maxSpecialPricing);

        const specialPricingColumns = [];
        for (let i = 0; i < maxSpecialPricing; i++) {
          specialPricingColumns.push({ field: `pricingFor_${i + 1}`, headerName: `Pricing per`, width: 150, align: 'center', headerAlign: 'center' });
        }
        setSpecialPricingColumns(specialPricingColumns);

        const transformedRows = data.data.map(item => {
        
          const pricingFields = {};
          item?.implantMarkerPricing.forEach((pric, index) => {
            pricingFields[`amount_${index + 1}`] = pric?.amount;
          });
        
          const specialPricingFields = {};
          item?.implantMarkerSpecialPricing.forEach((pricfor, index) => {
            specialPricingFields[`pricingFor_${index + 1}`] = pricfor?.pricingFor;
          });

          return {
            _id: item._id,
            valueName: item.valueName,
            allowNoteForLot: item.allowNoteForLot ? true : false,
            isLotRequired: item.isLotRequired ? true : false,
            isSerialRequired: item.isSerialRequired ? true : false,
            allowNoteForSerial: item.allowNoteForSerial ? true : false,
            ...pricingFields,
            ...specialPricingFields,
            pricing: item?.implantMarkerPricing,
            specialPricing: item?.implantMarkerSpecialPricing,
          };
        });

        setRows(transformedRows);
        
      } catch (error) {
        console.error('Failed to fetch Implant Marker:', error);
        setRows([]);
      }
    };
  
    fetchImplantMarkers();
  }, []);

  const handleEdit = async (id) => {
    
    setShowEditImplantMarker(true);
    const selectedRow = rows.filter((row) => row._id === id);
    setSelectedRowData(selectedRow);
  };

  const handleDelete = (id) => {

    setShowDeleteModal(true);
    // setRows(rows.filter(row => row._id !== id)); 
  };
  
  const handleRowClick = (row) => { 
    const { _id } = row;

    setSelectedRowId(_id === selectedRowId ? null : _id);
  };

  // const handleModalClose = () => {
  //   setOpen(false);
  //   setEditData({});
  // };

  // const handleSave = async () => {
  //   try {

  //     const putData = {
  //       ...editData,
  //       selectedRowData,
  //     }


  //     const response = await fetch(`https://hms.backend.hiragroupcloud.com/api/implant-markers/${editData._id}`, {
  //       method: 'PUT',
  //       headers: {
  //         'Content-Type': 'application/json',
  //       },
  //       body: JSON.stringify(editData),
  //     });
  
  //     if (!response.ok) {
  //       throw new Error('Failed to update data');
  //     }
  
  //     const updatedRow = await response.json();

  //     setRows(rows.map(row => (row._id === updatedRow.data._id ? updatedRow.data : row)));
  
  //     handleModalClose();
  //   } catch (error) {
  //     console.error('Error updating data:', error);
  //   }
  // };

  const filteredRows = rows.filter(row =>
    Object.values(row).some(value =>
      value.toString().toLowerCase().includes(searchTerm.toLowerCase())
    )
  );

  const baseColumns = [
    { field: 'valueName', headerName: 'Name', width: 150 },
      // { field: 'defaultprice', headerName: 'Default Price', width: 200, align: 'center', headerAlign: 'center' },
      // { field: 'priceper', headerName: 'Price Per', width: 150, align: 'center', headerAlign: 'center' },
  ];

  const allColumns = [
    ...baseColumns,
    ...pricingColumns,
    ...specialPricingColumns,
  ];

  return (
    <>
      <h2 className="title">Implant Markers</h2> 
      <div style={{backgroundColor:"#f4f4f4",padding:"10px",width:"1560px",margin:'0 auto'}}>
      <div className="search">
        <div className="row align-items-center">
          
            <div className="col-md-6 d-flex justify-content-start">
              <input
                type="text"
                id="searchInput"
                className="form-control"
                placeholder="Search..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </div>
         
          <div className="col-md-6 d-flex justify-content-end">
          <Link to="/AddImplantMarkers" className="btn btn-primary"
          style={{backgroundColor:"#004aad",borderColor:"#004aad"}}>
        Add
      </Link>
          </div>
        </div>
      </div>

      <div style={{ height: 350, width: '100%', position: 'relative', marginTop: '2%', background:'#f0f0f5' }}>
        <DataGrid
      rows={filteredRows}
      columns={allColumns}
          pageSize={5}
          rowSelected={selectedRowId !== null}
          onRowClick={(params) => handleRowClick(params.row)}
          getRowId={(row) => (row._id)}
          components={{
            Toolbar: () => null,
          }}
          sx={{
            '& .MuiDataGrid-columnHeaderTitle': {
              fontWeight: 'bold',
            }, 
            '& .MuiDataGrid-cell:focus': {
              outline: 'none',  
            },
            '& .MuiDataGrid-cell:focus-within': {
              outline: 'none',  
            },
          }}
        />
        {selectedRowId !== null && (
          <div
            style={{
              position: 'absolute',
              top: rows.findIndex(row => row._id === selectedRowId) * 52 + 48,
              right: '10px',
              display: 'flex',
              marginTop: '15px'
            }}
          >
             <Button
              variant="contained"
              color="primary"
              onClick={() => handleEdit(selectedRowId)}
              sx={{ marginRight: 1 }}
            >
              Edit
            </Button>
            <Button
              variant="contained"
              sx={{ backgroundColor: 'red', '&:hover': { backgroundColor: '#c62828' } }}
              onClick={() => handleDelete(selectedRowId)}
            >
              Delete
            </Button>
          </div>
        )}
      </div>
      </div>
      <EditImplantMarker 
        showEditImplantMarker={showEditImplantMarker} 
        handleEditImplantMarkerClose={() => setShowEditImplantMarker(false)} 
        selectedRowData={selectedRowData}
        editRows = {rows}
        onRowsUpdate = {onRowsUpdate}
      />
      <DeleteModal 
        showDeleteModal={showDeleteModal} 
        handleClose={() => setShowDeleteModal(false)} 
        selectedRowId={selectedRowId}
      />
    </>
  );
};

export default ImplantMarkers; 
